import { useUserRole } from 'hooks/helpers';
import { useUserStore } from 'store/user';
import { useApplicationStore } from 'store/application';
import { useFeatureTogglesStore } from 'store/feature-toggling';

import { REVOKED_STATUS } from 'models/user.model';
import {
  getCommonItems,
  getAdminAccessItems,
  getUserAccessItems,
} from './getMenuItems';
import { useMemo } from 'react';
import { MainMenu } from '@epam/promo';
import { useNavigationHandler } from 'hooks';

export const Navbar = () => {
  const user = useUserStore((state) => state.user);
  const { isGuest } = useUserRole();
  const { isLoading } = useApplicationStore((state) => state);
  const { isFeatureEnabled } = useFeatureTogglesStore();
  const handleNavigation = useNavigationHandler();

  const hasUserAccessToDashboard = useMemo(
    () => isGuest || user?.status === REVOKED_STATUS,
    [isGuest, user?.status],
  );

  const menuItems = useMemo(() => {
    if (!user) return getCommonItems(isLoading, handleNavigation);

    if (hasUserAccessToDashboard) {
      return getUserAccessItems(user);
    }

    return getAdminAccessItems(
      isLoading,
      handleNavigation,
      user,
      isFeatureEnabled,
    );
  }, [
    user,
    hasUserAccessToDashboard,
    handleNavigation,
    isLoading,
    isFeatureEnabled,
  ]);

  return <MainMenu items={menuItems} />;
};
